import React from "react";
import { FaBuilding } from "react-icons/fa";
import Popup from "../../../../../components/Popup";



export function CompanyInfoPopUp(props) {
    /* const [showEdit, setShowEdit] = useState(false);
    useEffect(() => {
        props.setVisibility(false);
    }, [showEdit])

    useEffect(() => {
        if(props.visibility === false)
            props.setVisibleEdit(true);
    }, [props.visibility]) */
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={"Empresa"}
            icon={<FaBuilding />}
        >
            <div className="records-element-info">
                <p><b>Nome: </b>{props.empresa && props.empresa.nome ? props.empresa.nome : ""}</p>
                <p><b>Nome Fantasia: </b>{props.empresa && props.empresa.nome_fantasia ? props.empresa.nome_fantasia : ""}</p>
                <p><b>Razão Social: </b>{props.empresa && props.empresa.razao_social ? props.empresa.razao_social : ""}</p>
                <p><b>Moeda: </b>{props.empresa && props.empresa.moeda ? props.empresa.moeda : ""}</p>
                <p><b>Contas Bancárias:</b></p>
                {
                    !props.empresa.contas_bancarias || props.empresa.contas_bancarias.length === 0 ?
                        null
                        :
                        props.empresa.contas_bancarias.map(conta_bancaria => {
                            return (
                                <p key={conta_bancaria.id}>{`Banco: ${conta_bancaria.banco}, Agência: ${conta_bancaria.agencia}, Conta: ${conta_bancaria.numero}`}</p>
                            )
                        })
                }
            </div>
        </Popup>
    )
}